// src/components/HomeAbout/ResumePopup.js
import React from 'react';
import './ResumePopup.css';

// Replace with the actual path to your resume PDF
import ResumePDF from '../../../Assets/resume/Srihari_latest.pdf';

const ResumePopup = ({ onClose }) => {
  return (
    <div className="resumepopup-overlay" onClick={onClose}>
      <div className="resumepopup-content" onClick={(e) => e.stopPropagation()}>
        {/* Fixed Top Bar */}
        <div className="resumepopup-topbar">
          <div className="resumepopup-name">Srihari Muppalla</div>
          <a
            href={ResumePDF}
            download="Srihari_Muppalla_Resume.pdf"
            className="resumepopup-download-btn"
          >
            Download Resume
          </a>
          <button className="resumepopup-close" onClick={onClose}>
            ×
          </button>
        </div>
        {/* Resume Preview */}
        <div className="resumepopup-preview">
          <iframe
            src={ResumePDF}
            title="Srihari Muppalla Resume"
            className="resumepopup-iframe"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default ResumePopup;